/**
 * Name: Edit Playlists Main
 * Author: @Gaurav
 * Date: 20-07-2021
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Sidebar from '../../components/SideBar';
import NavBar from '../../components/NavBarSearchSong';
import Settings from '../../assets/Settings.png';
import search from '../../assets/ic_search.png';
import CopyIcn from '../../assets/copy_icn.svg';
import EditIcn from '../../assets/edit_icn.svg';
import Delete from '../../assets/Delete.png';
import LazyImage from '../../components/LazyImage';
// import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import '../../pages/EditPlaylistMain/EditPlaylistMain.scss';
import { _showAlert, formatDateToDisplay } from '../../utils';
import { LoaderSpinner } from '../../components';
import AlertModal from '../../components/Modal';
import DownloadIcon from '../../components/Svgs/DownloadIcon.svg';
import DeleteIconSvg from '../../components/Svgs/DeleteIcon.svg.js';
import WarningIcon from '../../components/Svgs/WarningIcon.svg.js';
import RoundButton from '../../components/RoundButton';
import Popup from '../../components/Popup';
import ApiCaller from '../../redux/ApiCaller';
import { CircularProgress, Tooltip } from '@material-ui/core';
import { useHistory } from 'react-router-dom/';
import { Autocomplete, TextField } from '@mui/material';
import { colorIsDarkSimple } from '../../generalConstant';
import SortIndicator from '../../components/SortIndicator';
import PlaylistCustomerDialog from '../../components/PlaylistManagement/PlaylistCustomerDialog';
import PlaylistCopySongsDialog from '../../components/PlaylistManagement/PlaylistCopySongsDialog';
import PlaylistActionIcon from '../../components/PlaylistManagement/PlaylistActionIcon';

/**
 * style for material ui table
 */
const useStyles = makeStyles({
  table: {
    minWidth: 700,
    borderRadius: 30,
  },
});

function EditPlaylistMain(props) {
  const classes = useStyles();

  /**
   * getting state from redux store
   */
  const { getAllPlaylist, deletePlaylist, newPlaylistRequestData, tagList, deleteSongs } = useSelector((state) => ({
    getAllPlaylist: state.getAllPlaylist.result,
    deletePlaylist: state.deletePlaylist.result,
    newPlaylistRequestData: state.newPlaylist.result,
    tagList: state.tagList.result,
    deleteSongs: state.deleteSongs,
  }));

  const dispatch = useDispatch();
  const history = useHistory();

  const [searchInput, setSearchInput] = useState('');
  const [isLoading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [deleteSelectedPlaylist, setDeleteSelectedPlaylist] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [playlistName, setPlaylistName] = useState('');
  const [isCreating, setIsCreating] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [permanentDeletePopup, setPermanentDeletePopup] = useState({ isOpen: false, playlist: null });
  const [deleteStatus, setDeleteStatus] = useState('idle'); // idle, deleting_songs, songs_deleted, deleting_playlist, done, error
  const [deleteError, setDeleteError] = useState('');
  const [isPermanentDeleteInProgress, setIsPermanentDeleteInProgress] = useState(false);
  const [customerDialogPlaylist, setCustomerDialogPlaylist] = useState(null);
  const [copyDialogPlaylist, setCopyDialogPlaylist] = useState(null);
  const [previewPlaylist, setPreviewPlaylist] = useState(null);
  const [previewIndex, setPreviewIndex] = useState(0);

  //* for downloading playlist
  const [downloadingPlaylistIndexes, setDownloadingPlaylistIndexes] = useState([]);

  // Sorting state
  const [sortConfig, setSortConfig] = useState({ key: 'createdAt', direction: 'desc' });

  // get URL data one of /royalties/edit-playlist-main or /non-royalties/edit-playlist-main
  const urlData = props.location.pathname.split('/');
  const isRoyalties = urlData.includes('royalties');

  /**
   * Close Modal
   */
  const handleClose = () => {
    setOpen(false);
  };

  /**
   * handle the delete api request
   * watch the changes of the deletePlaylist state
   */
  useEffect(() => {
    if (deletePlaylist.status === 200) {
      if (isPermanentDeleteInProgress) {
        setDeleteStatus('done');
        setIsPermanentDeleteInProgress(false);
      } else {
        setLoading(false);
        _showAlert('Deleted successfully.', 'success');
      }
      dispatch({ type: 'GET_ALL_PLAYLIST', payload: searchInput, tagIds: selectedTags });
      dispatch({ type: 'CLEAR_STATE', actionName: 'DELETE_PLAYLIST' });
    }
    if (deletePlaylist.error) {
      if (isPermanentDeleteInProgress) {
        setDeleteStatus('error');
        setDeleteError(deletePlaylist.error);
        setIsPermanentDeleteInProgress(false);
      } else {
        setLoading(false);
        _showAlert(deletePlaylist.error, 'error');
      }
      dispatch({ type: 'CLEAR_STATE', actionName: 'DELETE_PLAYLIST' });
    }
  }, [deletePlaylist]);

  useEffect(() => {
    if (!isPermanentDeleteInProgress) return;

    if (deleteStatus === 'deleting_songs' && deleteSongs.status === 'success') {
      const playlist = permanentDeletePopup.playlist;
      dispatch({ type: 'DELETE_SONGS_RESET' });
      setDeleteStatus('deleting_playlist');
      dispatch({ type: 'DELETE_PLAYLIST', payload: { ids: [playlist.id] } });
    } else if (deleteStatus === 'deleting_songs' && deleteSongs.status === 'failed') {
      dispatch({ type: 'DELETE_SONGS_RESET' });
      setDeleteStatus('error');
      setDeleteError(deleteSongs.result?.error || 'Failed to delete songs.');
      setIsPermanentDeleteInProgress(false);
    }
  }, [deleteSongs, deleteStatus, isPermanentDeleteInProgress]);

  /**
   * handle the get playlist api request
   * watch the changes of the getAllPlaylist state
   */
  useEffect(() => {
    if (getAllPlaylist.error) {
      _showAlert(getAllPlaylist.error, 'error');
    }
    setLoading(false);
  }, [getAllPlaylist]);

  /**
   * call the get playlist api
   * watch the local state searchInput changes to search the playlist
   */

  useEffect(() => {
    dispatch({ type: 'TAG_LIST' });
  }, []);

  useEffect(() => {
    dispatch({ type: 'GET_ALL_PLAYLIST', payload: searchInput, tagIds: selectedTags });
  }, [searchInput, selectedTags]);

  /**
   * handle the duplicate new playlist api call
   * watch the changes of the newPlaylistRequestData redux state
   */
  useEffect(() => {
    if (newPlaylistRequestData && newPlaylistRequestData.id) {
      _showAlert('Playlist has been created successfully.', 'success');
      dispatch({ type: 'GET_ALL_PLAYLIST', payload: '' });
    }
    if (newPlaylistRequestData.error) {
      setLoading(false);
      _showAlert(newPlaylistRequestData.error, 'error', 10000);
    }
  }, [newPlaylistRequestData]);

  /**
   * clear the redux state of the api called in this component while component unmount
   */
  useEffect(() => {
    return () => {
      dispatch({ type: 'CLEAR_STATE', actionName: 'NEW_PLAYLIST' });
      dispatch({ type: 'CLEAR_STATE', actionName: 'DELETE_PLAYLIST' });
      dispatch({ type: 'DELETE_SONGS_RESET' });
    };
  }, []);

  /**
   * will get called on click of edit icon
   */
  const handleEditClick = (selectedPlayList) => {
    props.history.push({
      pathname: isRoyalties ? '/royalties/edit-playlist-secondery' : '/non-royalties/edit-playlist-secondery',
      state: { selectedPlayList },
    });
  };

  /**
   * will get called on click of delete icon of row
   * will call the delete playlist api
   */

  const handleDelete = (item) => {
    setOpen(false);
    setLoading(true);
    dispatch({ type: 'DELETE_PLAYLIST', payload: { ids: [item.id] } });
  };
  const handleSort = (key) => {
    let direction = 'desc';
    let newKey = key;

    if (sortConfig.key === key) {
      if (sortConfig.direction === 'desc') {
        direction = 'asc';
      } else {
        newKey = null;
      }
    }

    setSortConfig({ key: newKey, direction });
  };

  const sortPlaylists = (playlists) => {
    if (!sortConfig.key) return playlists;

    return [...playlists].sort((a, b) => {
      if (sortConfig.key === 'createdAt') {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return sortConfig.direction === 'asc' ? dateA - dateB : dateB - dateA;
      }

      if (sortConfig.key === 'name') {
        const nameA = a.name || '';
        const nameB = b.name || '';
        return sortConfig.direction === 'asc' ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
      }

      if (sortConfig.key === 'editor') {
        const editorA = a.lastEditedBy?.username || '';
        const editorB = b.lastEditedBy?.username || '';
        return sortConfig.direction === 'asc' ? editorA.localeCompare(editorB) : editorB.localeCompare(editorA);
      }

      return 0;
    });
  };

  /**
   * will get called on click of duplicate icon of row
   * will call the new playlist api with selected playlist name and songs
   */
  const handleDuplicate = (playlist) => {
    setLoading(true);
    dispatch({ type: 'NEW_PLAYLIST', payload: { name: playlist.name, songs: playlist.songs } });
  };

  const handlePermanentDelete = () => {
    const playlist = permanentDeletePopup.playlist;
    if (!playlist) return;

    setIsPermanentDeleteInProgress(true);
    setDeleteStatus('deleting_songs');

    const songIds = playlist.songs.map((song) => song.id);

    if (songIds.length > 0) {
      dispatch({ type: 'DELETE_SONGS_RESET' });
      dispatch({ type: 'DELETE_SONGS', payload: { ids: songIds } });
    } else {
      // No songs to delete, move to deleting playlist
      setDeleteStatus('deleting_playlist');
      dispatch({ type: 'DELETE_PLAYLIST', payload: { ids: [playlist.id] } });
    }
  };

  const downloadPlaylist = async (playlist, index) => {
    const updatedDownloadingIndexs = [...downloadingPlaylistIndexes, index];
    setDownloadingPlaylistIndexes(updatedDownloadingIndexs);

    _showAlert('Your playlist is downloading', 'success');
    await ApiCaller(`/v1/admin/playlists/${playlist.id}/download`, 'GET')
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${playlist.name}.zip`);

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        _showAlert(error.message, 'error');
      })
      .finally(() => {
        const updatedDownloadingIndexs = [...downloadingPlaylistIndexes];
        updatedDownloadingIndexs.splice(updatedDownloadingIndexs.indexOf(index), 1);
        setDownloadingPlaylistIndexes(updatedDownloadingIndexs);
      });
  };

  const filteredPlaylists = Array.isArray(getAllPlaylist)
    ? getAllPlaylist?.filter((playlist) => (isRoyalties ? playlist.type === 3 : playlist.type === 4))
    : [];

  //* New Playlist
  const handleCreatePlaylist = () => {
    setIsCreating(true);
    dispatch({ type: 'NEW_PLAYLIST', payload: { name: playlistName, songs: [], type: isRoyalties ? 3 : 4 } });
    setIsCreating(false);
    setIsPopupOpen(false);
  };

  useEffect(() => {
    // clear the state of new playlist while closing the component
    return () => {
      dispatch({ type: 'CLEAR_STATE', actionName: 'NEW_PLAYLIST' });
    };
  }, []);

  const isAdmin = JSON.parse(sessionStorage.getItem('authData'))?.user?.userRole === 1;
  const previewSongs = previewPlaylist?.songs || [];
  const previewSong = previewSongs[previewIndex] || null;

  return (
    <div className="main edit-playlist-main">
      {isLoading && <LoaderSpinner />}
      <div className="sidebar">
        <Sidebar />
      </div>

      <AlertModal open={open} onClose={handleClose} handelDelete={() => handleDelete(deleteSelectedPlaylist)} />
      <div className="leftPortion">
        <NavBar
          data="Edit Playlists"
          icon={Settings}
          currentRouteName="Playlists"
          breadcrumbsPath="Edit Playlists"
          showPlayer={true}
          currentSong={previewSong}
          hasNextSong={previewIndex < previewSongs.length - 1}
          onNextSong={() => setPreviewIndex((index) => index + 1)}
          hasPrevSong={previewIndex > 0}
          onPrevSong={() => setPreviewIndex((index) => index - 1)}
          onClosePlayer={() => setPreviewPlaylist(null)}
        />
        <div className="content">
          <div className="filtersMain">
            <div className="upperRow">
              <div className="search_row">
                <input
                  className="input_field"
                  placeholder="Search something here..."
                  type="text"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                />
                <img src={search} />
              </div>
              <div className="btn-group">
                <RoundButton
                  btnText="Royalties"
                  className={isRoyalties ? '' : 'not-selected'}
                  handleClick={() => {
                    history.push('/royalties/edit-playlist-main');
                  }}
                />
                <RoundButton
                  btnText="unRoyalties"
                  className={!isRoyalties ? '' : 'not-selected'}
                  handleClick={() => {
                    history.push('/non-royalties/edit-playlist-main');
                  }}
                />
              </div>
              <Autocomplete
                style={{ width: 250, marginLeft: 10 }}
                size="small"
                multiple
                limitTags={2}
                id="tags-outlined"
                options={tagList?.tags || []}
                getOptionLabel={(option) => option?.name}
                defaultValue={[]}
                filterSelectedOptions
                onChange={(event, newValue) => {
                  const selectedTagIds = newValue?.map((tag) => tag.id);
                  setSelectedTags(selectedTagIds);
                }}
                renderInput={(params) => <TextField {...params} placeholder="Tags" />}
              />
            </div>
            <div className="add-btn">
              <RoundButton btnText="New Playlist" handleClick={() => setIsPopupOpen(true)} />
            </div>
          </div>

          <TableContainer className="tbl_wraper" component={Paper}>
            <Table className={classes.table} stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell>{/* <Checkbox inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} /> */}</TableCell>
                  <TableCell className="table_font">Result</TableCell>
                  <TableCell
                    onClick={() => handleSort('createdAt')}
                    style={{ cursor: 'pointer', userSelect: 'none' }}
                  >
                    Date<SortIndicator sortConfig={sortConfig} columnKey="createdAt" />
                  </TableCell>
                  <TableCell
                    onClick={() => handleSort('name')}
                    style={{ cursor: 'pointer', userSelect: 'none' }}
                  >
                    Playlist Name<SortIndicator sortConfig={sortConfig} columnKey="name" />
                  </TableCell>
                  <TableCell>Tags</TableCell>
                  <TableCell
                    onClick={() => handleSort('editor')}
                    style={{ cursor: 'pointer', userSelect: 'none' }}
                  >
                    Editor<SortIndicator sortConfig={sortConfig} columnKey="editor" />
                  </TableCell>
                  <TableCell className="text_center playlist-actions-cell">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(getAllPlaylist)
                  ? sortPlaylists(filteredPlaylists).map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{/* <Checkbox inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} /> */}</TableCell>
                      <TableCell align="justify" style={{ fontWeight: 'bold' }}>
                        <p style={{ paddingTop: '20px' }}>#{++index}</p>
                        {row.image ? (
                          <LazyImage
                            src={`${process.env.REACT_APP_MEDIA_URL}playlist_images/${row.image}?${new Date().getTime()}`}
                            crossOrigin="anonymous"
                            alt="not-found"
                            className="imageContainerGet"
                          />
                        ) : (
                          <div className="thumbNail">
                            <p>{row.name?.[0]}</p>
                          </div>
                        )}
                      </TableCell>
                      <TableCell>{formatDateToDisplay(row.createdAt)}</TableCell>
                      <TableCell>{row.name}</TableCell>
                      <TableCell>
                        <div
                          style={{
                            display: 'flex',
                            maxWidth: '200px',
                            flexWrap: 'wrap',
                          }}
                        >
                          {row.tags && row.tags.length > 0 ? (
                            row.tags.map((tag) => (
                              <div
                                className="tag_box"
                                key={tag.id}
                                style={{
                                  background: tag.color,
                                  color: colorIsDarkSimple(tag.color) ? 'white' : 'black',
                                  maxWidth: '200px',
                                  height: '24px',
                                  overflow: 'hidden',
                                }}
                              >
                                {tag.name.length > 25 ? tag.name.slice(0, 25) + '...' : tag.name}
                              </div>
                            ))
                          ) : (
                            <div>-</div>
                          )}
                        </div>
                      </TableCell>
                      <TableCell>{row.lastEditedBy?.username || '—'}</TableCell>
                      <TableCell className="playlist-actions-cell">
                        <span className="action_icn">
                          <PlaylistActionIcon kind="listen" label={`Listen to ${row.name}`} disabled={!row.songs?.length} onClick={() => { setPreviewPlaylist(row); setPreviewIndex(0); }} />
                          <PlaylistActionIcon kind="copy" label={`Copy songs from ${row.name}`} disabled={!row.songs?.length} onClick={() => setCopyDialogPlaylist(row)} />
                          {isAdmin && <PlaylistActionIcon kind="customers" label={`View and assign customers for ${row.name}`} onClick={() => setCustomerDialogPlaylist(row)} />}
                          {isAdmin && (downloadingPlaylistIndexes.includes(index) ? (
                            <span className="playlist-action-loading"><CircularProgress size={20} /></span>
                          ) : (
                            <Tooltip title="Download playlist" arrow>
                              <button className="playlist-action-icon" type="button" aria-label={`Download ${row.name}`} onClick={() => downloadPlaylist(row, index)}>
                                <DownloadIcon className="icon" />
                              </button>
                            </Tooltip>
                          ))}
                          <Tooltip title="Duplicate playlist" arrow>
                            <button className="playlist-action-icon" type="button" aria-label={`Duplicate ${row.name}`} onClick={() => handleDuplicate(row)}>
                              <img alt="" src={CopyIcn} />
                            </button>
                          </Tooltip>
                          <Tooltip title="Edit playlist" arrow>
                            <button className="playlist-action-icon" type="button" aria-label={`Edit ${row.name}`} onClick={() => handleEditClick(row)}>
                              <img alt="" src={EditIcn} />
                            </button>
                          </Tooltip>
                          {isAdmin && (
                            <>
                              <Tooltip title="Delete playlist, keep songs" arrow>
                                <button className="playlist-action-icon" type="button" aria-label={`Delete ${row.name} and keep its songs`} onClick={() => {
                                  setOpen(true);
                                  setDeleteSelectedPlaylist(row);
                                }}>
                                  <img alt="" src={Delete} />
                                </button>
                              </Tooltip>
                              <Tooltip title="Permanently delete playlist and songs" arrow>
                                <button className="playlist-action-icon" type="button" aria-label={`Permanently delete ${row.name} and its songs`} onClick={() => {
                                  setPermanentDeletePopup({ isOpen: true, playlist: row });
                                }}>
                                  <DeleteIconSvg className="icon" />
                                </button>
                              </Tooltip>
                            </>
                          )}
                        </span>
                      </TableCell>
                    </TableRow>
                  ))
                  : null}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
      {
        <Popup open={isPopupOpen} onClose={() => setIsPopupOpen(false)}>
          <div className="create_playlist">
            <p className="header">New Playlist</p>
            <input placeholder="Playlist Name" type="text" onChange={(e) => setPlaylistName(e.target.value)} />
            <RoundButton className="add-btn" btnText={isCreating ? 'Creating...' : 'Create Playlist'} handleClick={handleCreatePlaylist} />
            {isCreating && <LoaderSpinner />}
          </div>
        </Popup>
      }
      <PlaylistCustomerDialog
        playlist={customerDialogPlaylist}
        open={!!customerDialogPlaylist}
        onClose={() => setCustomerDialogPlaylist(null)}
      />
      <PlaylistCopySongsDialog
        playlist={copyDialogPlaylist}
        open={!!copyDialogPlaylist}
        onClose={() => setCopyDialogPlaylist(null)}
        onSuccess={() => dispatch({ type: 'GET_ALL_PLAYLIST', payload: searchInput, tagIds: selectedTags })}
      />
      {permanentDeletePopup.isOpen && (
        <Popup
          open={permanentDeletePopup.isOpen}
          onClose={() => {
            if (deleteStatus !== 'deleting_songs' && deleteStatus !== 'deleting_playlist') {
              setPermanentDeletePopup({ isOpen: false, playlist: null });
              setDeleteStatus('idle');
              setDeleteError('');
              setIsPermanentDeleteInProgress(false);
            }
          }}
          dialogClassName="permanent-delete-dialog"
        >
          <div className="permanent_delete_playlist_popup">
            {deleteStatus === 'idle' && (
              <>
                <WarningIcon />
                <p className="header">Permanent Delete Playlist</p>
                <p className="description">
                  You are about to permanently delete the playlist
                  <strong> "{permanentDeletePopup.playlist?.name}"</strong> and all of its songs from the server. This action cannot be undone.
                </p>
                <p className='songs_list_header'>Songs to be deleted:</p>
                <div className="songs_list">
                  {permanentDeletePopup.playlist?.songs?.length > 0 ? (
                    permanentDeletePopup.playlist?.songs?.map((song, index) => <p key={song.id}> {++index}. {song.name || song.fileName}</p>)
                  ) : (
                    <p>No songs in this playlist.</p>
                  )}
                </div>
                <div className="btn-group">
                  <RoundButton
                    btnText="Cancel"
                    className="not-selected"
                    handleClick={() => setPermanentDeletePopup({ isOpen: false, playlist: null })}
                  />
                  <RoundButton btnText="Confirm" handleClick={handlePermanentDelete} />
                </div>
              </>
            )}
            {(deleteStatus === 'deleting_songs' || deleteStatus === 'deleting_playlist') && (
              <>
                <p className="header">Deleting Playlist</p>
                <CircularProgress />
                <p className="status-text">
                  {deleteStatus === 'deleting_songs' ? 'Deleting songs from server...' : 'Deleting playlist...'}
                </p>
                <div className="songs_list">
                  {permanentDeletePopup.playlist?.songs?.map((song) => (
                    <p key={song.id} className="deleting">
                      {song.name || song.fileName}
                    </p>
                  ))}
                </div>
              </>
            )}
            {deleteStatus === 'done' && (
              <>
                <p className="header">Success</p>
                <p className='description'>Playlist and its songs have been permanently deleted.</p>
                <RoundButton
                  btnText="Close"
                  handleClick={() => {
                    setPermanentDeletePopup({ isOpen: false, playlist: null });
                    setDeleteStatus('idle');
                    setIsPermanentDeleteInProgress(false);
                  }}
                />
              </>
            )}
            {deleteStatus === 'error' && (
              <>
                <p className="header">Error</p>
                <p>{deleteError}</p>
                <RoundButton
                  btnText="Close"
                  handleClick={() => {
                    setPermanentDeletePopup({ isOpen: false, playlist: null });
                    setDeleteStatus('idle');
                    setDeleteError('');
                    setIsPermanentDeleteInProgress(false);
                  }}
                />
              </>
            )}
          </div>
        </Popup>
      )}
    </div>
  );
}

export default EditPlaylistMain;
